import { useState } from 'react';
import { createContainer } from 'unstated-next';

// 评论相关状态
const useStore = (
    initialState = {
        list: [],
        subjectId: '',
        page: 1,
        total: 0,
        topIdList: [],
        showReplyModal: false,
        replyLisRootId: '',
        replyList: [],
        replyPage: 1,
        likeMessage: {},
        docMeta: {
            docUrl: '',
            docName: '',
            skey: '',
        },
    },
) => {
    const [states, setStates] = useState(initialState);

    const changeStates = newListStates => {
        setStates(prevStates => Object.assign({}, prevStates, newListStates));
    };

    return { states, changeStates };
};

export const Store = createContainer(useStore);
